<template>
    <el-dialog :title="(formData.edit? $t('Update Class'):$t('Create Class'))" :visible.sync="dialogFormVisible" :before-close="handleClose" @open="handleOpen('formData')" width="30%">
        <el-form label-position="top" :model="formData" ref="formData" class="demo-dynamic">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('Class No.')" prop="class_number" :rules="[{ required: true, message: $t('This field is required')}, {
                        pattern: /(^\d{1,8})+$/,
                        trigger: ['blur', 'change'],
                        message: $t('Invalid number format')
                    }]">
                    <el-input v-model="formData.class_number"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('Name')" prop="name" :rules="[{ required: true, message: $t('This field is required')}]">
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('Class Type')" prop="class_type" :rules="[{ required: true, message: $t('This field is required')}]">
                    <el-radio-group v-model="formData.class_type">
                        <el-radio v-for="clsType in classTypes" :key="clsType.value" :label="clsType.value">{{ $t(clsType.label) }}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="24">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('formData')" size="medium">{{ (formData.edit?
                        $t('Update'):$t('Save')) }}</el-button>
                    <el-button type="cancel" @click="$emit('popup',false)" size="medium">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-col>
            <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            dialogFormVisible: Boolean,
            rowData: Object
        },
        data() {
            return {
                formData: {},
                formLabelWidth: '120px',
                classTypes: process.env.KIPAKI_class_types
            };
        },
        methods: {
            handleOpen() {
                this.formData = Object.assign({}, this.rowData);
                this.$nextTick(() => {
                    this.$refs['formData'].clearValidate();
                })
            },
            handleClose() {
                this.$emit('popup', false)
            },
            updateData(row) {
                return request({
                        url: "account-classes/" + row.slug,
                        method: "PATCH",
                        data: row
                    })
                    .then(response => {
                        this.$emit('popupupdate', response.data.data);
                        this.$emit('popup', false);
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.formData.edit)
                            return this.updateData(this.formData);
                        request({
                                url: "account-classes",
                                method: "post",
                                data: this.formData
                            })
                            .then(response => {
                                this.$emit('popup', false);
                                this.$emit('popupsave', false);
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/AccountClasses/Form.vue